import { gql } from '@apollo/client'

export const CHANGE_SHIPMENT_NUMBER = gql`
  mutation ChangeShipmentNumber($id: ID!, $shipmentNumber: String!) {
    changeShipmentNumber(input: { id: $id, shipmentNumber: $shipmentNumber }) {
      id
      shipmentNumber
    }
  }
`

export const CREATE_SHIPMENT = gql`
  mutation CreateShipment($id: ID!, $shipmentNumber: String!, $shipmentStatus: String) {
    createShipment(input: { id: $id, shipmentNumber: $shipmentNumber, shipmentStatus: $shipmentStatus }) {
      id
    }
  }
`

export const DELETE_SHIPMENT = gql`
  mutation DeleteShipment($id: ID!) {
    deleteShipment(input: { id: $id }) {
      id
    }
  }
`

// The mutation to update the shipment status
export const UPDATE_SHIPMENT_STATUS = gql`
  mutation UpdateShipmentStatus($id: ID!, $shipmentStatus: String!) {
    updateShipmentStatus(input: { id: $id, shipmentStatus: $shipmentStatus }) {
      id
      shipmentStatus
    }
  }
`

// The mutation to assign the shipment to a release
export const ASSIGN_SHIPMENT_TO_RELEASE = gql`
  mutation AssignShipmentToRelease($shipmentID: ID!, $release: String!) {
    assignShipmentToRelease(input: { shipmentID: $shipmentID, release: $release }) {
      id
      release
    }
  }
`

// The mutation to assign the shipment priority
export const ASSIGN_SHIPMENT_PRIORITY = gql`
  mutation AssignShipmentPriority($shipmentID: ID!, $priority: String!) {
    assignShipmentPriority(input: { shipmentID: $shipmentID, priority: $priority }) {
      id
      priority
    }
  }
`

// The mutation to change the trailer number
export const CHANGE_TRAILER_NUMBER = gql`
  mutation ChangeTrailerNumber(
    $id: ID!
    $shipmentOwnerWorkspaceID: ID!
    $trailerNumber: String
    $actionType: AssetActionTypeEnum
  ) {
    changeTrailerNumber(
      input: {
        id: $id
        shipmentOwnerWorkspaceID: $shipmentOwnerWorkspaceID
        trailerNumber: $trailerNumber
        actionType: $actionType
      }
    ) {
      id
      trailerNumber
    }
  }
`

// The mutation to change the truck number
export const CHANGE_TRUCK_NUMBER = gql`
  mutation ChangeTruckNumber(
    $id: ID!
    $shipmentOwnerWorkspaceID: ID!
    $truckNumber: String
    $actionType: AssetActionTypeEnum
  ) {
    changeTruckNumber(
      input: {
        id: $id
        shipmentOwnerWorkspaceID: $shipmentOwnerWorkspaceID
        truckNumber: $truckNumber
        actionType: $actionType
      }
    ) {
      id
      truckNumber
    }
  }
`

// The mutation to bulk update shipment statuses
export const BULK_UPDATE_SHIPMENT_STATUS = gql`
  mutation BulkUpdateShipmentStatus($shipmentStatus: String!, $shipmentIDs: [ID!]!) {
    bulkUpdateShipmentStatus(input: { shipmentStatus: $shipmentStatus, shipmentIDs: $shipmentIDs }) {
      shipments {
        id
        shipmentStatus
      }
    }
  }
`
